/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/app'
import { Route as Char42RouteImport } from './routes/*'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthWaitUserRouteImport } from './routes/auth/wait-user'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthOauthcbRouteImport } from './routes/auth/oauthcb'
import { Route as AuthForgotRouteImport } from './routes/auth/forgot'
import { Route as AppInviteRouteImport } from './routes/app/invite'
import { Route as AppSidebarLayoutRouteImport } from './routes/app/_sidebar-layout'
import { Route as AppOnboardingIndexRouteImport } from './routes/app/onboarding/index'
import { Route as AppSidebarLayoutIndexRouteImport } from './routes/app/_sidebar-layout.index'
import { Route as AppSettingsSidebarSettingsLayoutRouteImport } from './routes/app/settings/_sidebar-settings-layout'
import { Route as AppProductIdRouteImport } from './routes/app/product/$id'
import { Route as AppProductTemplateNewRouteImport } from './routes/app/product-template/new'
import { Route as AppContentIdRouteImport } from './routes/app/content/$id'
import { Route as AppCheckCheckoutSessionOrgIdRouteImport } from './routes/app/check-checkout-session.$orgId'
import { Route as AppBookcallOrgIdRouteImport } from './routes/app/bookcall.$orgId'
import { Route as AppScreenRemovedOrgRouteImport } from './routes/app/_screen/removed-org'
import { Route as AppScreenNoBrandRouteImport } from './routes/app/_screen/no-brand'
import { Route as AppSidebarLayoutSeoStrategyIndexRouteImport } from './routes/app/_sidebar-layout.seo-strategy/index'
import { Route as AppSidebarLayoutProductsIndexRouteImport } from './routes/app/_sidebar-layout.products/index'
import { Route as AppSidebarLayoutBrandContextIndexRouteImport } from './routes/app/_sidebar-layout.brand-context/index'
import { Route as AppSidebarLayoutBlogsIndexRouteImport } from './routes/app/_sidebar-layout.blogs/index'
import { Route as AppSettingsSidebarSettingsLayoutUserRouteImport } from './routes/app/settings/_sidebar-settings-layout/user'
import { Route as AppSettingsSidebarSettingsLayoutNotificationsRouteImport } from './routes/app/settings/_sidebar-settings-layout/notifications'
import { Route as AppProductTemplateIdEditRouteImport } from './routes/app/product-template/$id.edit'
import { Route as AppFunnelIdLayoutFunnelRouteImport } from './routes/app/funnel/$id/_layout-funnel'
import { Route as AppSidebarLayoutSeoStrategyBrandIdRouteImport } from './routes/app/_sidebar-layout.seo-strategy/$brandId'
import { Route as AppSidebarLayoutProductsTemplatesRouteImport } from './routes/app/_sidebar-layout.products/templates'
import { Route as AppFunnelIdLayoutFunnelProductIndexRouteImport } from './routes/app/funnel/$id/_layout-funnel.product-index'
import { Route as AppFunnelBulkImportIdIndexRouteImport } from './routes/app/funnel/bulk-import/$id/index'
import { Route as AppSidebarLayoutSeoStrategyBrandIdIndexRouteImport } from './routes/app/_sidebar-layout.seo-strategy/$brandId/index'
import { Route as AppSidebarLayoutProductsBulkImportIndexRouteImport } from './routes/app/_sidebar-layout.products/bulk-import/index'
import { Route as AppFunnelProductIdLayoutFunnelRouteImport } from './routes/app/funnel/product/$id/_layout-funnel'
import { Route as AppFunnelBulkImportIdLoadingRouteImport } from './routes/app/funnel/bulk-import/$id/loading'
import { Route as AppFunnelIdLayoutFunnelTitleRouteImport } from './routes/app/funnel/$id/_layout-funnel.title'
import { Route as AppFunnelIdLayoutFunnelOutlinesRouteImport } from './routes/app/funnel/$id/_layout-funnel.outlines'
import { Route as AppFunnelIdLayoutFunnelCustomizeContentRouteImport } from './routes/app/funnel/$id/_layout-funnel.customize-content'
import { Route as AppFunnelIdLayoutFunnelContentRouteImport } from './routes/app/funnel/$id/_layout-funnel.content'
import { Route as AppSidebarLayoutSeoStrategyBrandIdOverviewRouteImport } from './routes/app/_sidebar-layout.seo-strategy/$brandId/overview'
import { Route as AppSidebarLayoutSeoStrategyBrandIdKeywordsRouteImport } from './routes/app/_sidebar-layout.seo-strategy/$brandId/keywords'
import { Route as AppSidebarLayoutSeoStrategyBrandIdActionPlanRouteImport } from './routes/app/_sidebar-layout.seo-strategy/$brandId/action-plan'
import { Route as AppSidebarLayoutProductsBulkImportIdRouteImport } from './routes/app/_sidebar-layout.products/bulk-import/$id'
import { Route as AppFunnelProductIdLayoutFunnelIndexRouteImport } from './routes/app/funnel/product/$id/_layout-funnel.index'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout'
import { Route as AppFunnelProductIdLayoutFunnelProductInfoRouteImport } from './routes/app/funnel/product/$id/_layout-funnel.product-info'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout/users'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout/plan'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout/integrations'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout/brands'
import { Route as AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRouteImport } from './routes/app/settings/_sidebar-settings-layout/organization.$id/_tabs-layout/billing-legacy'

const AppSettingsRouteImport = createFileRoute('/app/settings')()
const AppFunnelIdRouteImport = createFileRoute('/app/funnel/$id')()
const AppFunnelProductIdRouteImport = createFileRoute(
  '/app/funnel/product/$id',
)()
const AppSettingsSidebarSettingsLayoutOrganizationIdRouteImport =
  createFileRoute('/app/settings/_sidebar-settings-layout/organization/$id')()

const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const Char42Route = Char42RouteImport.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWaitUserRoute = AuthWaitUserRouteImport.update({
  id: '/auth/wait-user',
  path: '/auth/wait-user',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOauthcbRoute = AuthOauthcbRouteImport.update({
  id: '/auth/oauthcb',
  path: '/auth/oauthcb',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/auth/forgot',
  path: '/auth/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const AppInviteRoute = AppInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppRoute,
} as any)
const AppSidebarLayoutRoute = AppSidebarLayoutRouteImport.update({
  id: '/_sidebar-layout',
  getParentRoute: () => AppRoute,
} as any)
const AppFunnelIdRoute = AppFunnelIdRouteImport.update({
  id: '/funnel/$id',
  path: '/funnel/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRoute,
} as any)
const AppSidebarLayoutIndexRoute = AppSidebarLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSidebarLayoutRoute,
} as any)
const AppSettingsSidebarSettingsLayoutRoute =
  AppSettingsSidebarSettingsLayoutRouteImport.update({
    id: '/_sidebar-settings-layout',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppProductIdRoute = AppProductIdRouteImport.update({
  id: '/product/$id',
  path: '/product/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProductTemplateNewRoute = AppProductTemplateNewRouteImport.update({
  id: '/product-template/new',
  path: '/product-template/new',
  getParentRoute: () => AppRoute,
} as any)
const AppContentIdRoute = AppContentIdRouteImport.update({
  id: '/content/$id',
  path: '/content/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckCheckoutSessionOrgIdRoute =
  AppCheckCheckoutSessionOrgIdRouteImport.update({
    id: '/check-checkout-session/$orgId',
    path: '/check-checkout-session/$orgId',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookcallOrgIdRoute = AppBookcallOrgIdRouteImport.update({
  id: '/bookcall/$orgId',
  path: '/bookcall/$orgId',
  getParentRoute: () => AppRoute,
} as any)
const AppScreenRemovedOrgRoute = AppScreenRemovedOrgRouteImport.update({
  id: '/_screen/removed-org',
  path: '/removed-org',
  getParentRoute: () => AppRoute,
} as any)
const AppScreenNoBrandRoute = AppScreenNoBrandRouteImport.update({
  id: '/_screen/no-brand',
  path: '/no-brand',
  getParentRoute: () => AppRoute,
} as any)
const AppFunnelProductIdRoute = AppFunnelProductIdRouteImport.update({
  id: '/funnel/product/$id',
  path: '/funnel/product/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSidebarLayoutSeoStrategyIndexRoute =
  AppSidebarLayoutSeoStrategyIndexRouteImport.update({
    id: '/seo-strategy/',
    path: '/seo-strategy/',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppSidebarLayoutProductsIndexRoute =
  AppSidebarLayoutProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppSidebarLayoutBrandContextIndexRoute =
  AppSidebarLayoutBrandContextIndexRouteImport.update({
    id: '/brand-context/',
    path: '/brand-context/',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppSidebarLayoutBlogsIndexRoute =
  AppSidebarLayoutBlogsIndexRouteImport.update({
    id: '/blogs/',
    path: '/blogs/',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppSettingsSidebarSettingsLayoutUserRoute =
  AppSettingsSidebarSettingsLayoutUserRouteImport.update({
    id: '/user',
    path: '/user',
    getParentRoute: () => AppSettingsSidebarSettingsLayoutRoute,
  } as any)
const AppSettingsSidebarSettingsLayoutNotificationsRoute =
  AppSettingsSidebarSettingsLayoutNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsSidebarSettingsLayoutRoute,
  } as any)
const AppProductTemplateIdEditRoute =
  AppProductTemplateIdEditRouteImport.update({
    id: '/product-template/$id/edit',
    path: '/product-template/$id/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppFunnelIdLayoutFunnelRoute = AppFunnelIdLayoutFunnelRouteImport.update({
  id: '/_layout-funnel',
  getParentRoute: () => AppFunnelIdRoute,
} as any)
const AppSidebarLayoutSeoStrategyBrandIdRoute =
  AppSidebarLayoutSeoStrategyBrandIdRouteImport.update({
    id: '/seo-strategy/$brandId',
    path: '/seo-strategy/$brandId',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppSidebarLayoutProductsTemplatesRoute =
  AppSidebarLayoutProductsTemplatesRouteImport.update({
    id: '/products/templates',
    path: '/products/templates',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppFunnelIdLayoutFunnelProductIndexRoute =
  AppFunnelIdLayoutFunnelProductIndexRouteImport.update({
    id: '/product-index',
    path: '/product-index',
    getParentRoute: () => AppFunnelIdLayoutFunnelRoute,
  } as any)
const AppSettingsSidebarSettingsLayoutOrganizationIdRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdRouteImport.update({
    id: '/organization/$id',
    path: '/organization/$id',
    getParentRoute: () => AppSettingsSidebarSettingsLayoutRoute,
  } as any)
const AppFunnelBulkImportIdIndexRoute =
  AppFunnelBulkImportIdIndexRouteImport.update({
    id: '/funnel/bulk-import/$id/',
    path: '/funnel/bulk-import/$id/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSidebarLayoutSeoStrategyBrandIdIndexRoute =
  AppSidebarLayoutSeoStrategyBrandIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSidebarLayoutSeoStrategyBrandIdRoute,
  } as any)
const AppSidebarLayoutProductsBulkImportIndexRoute =
  AppSidebarLayoutProductsBulkImportIndexRouteImport.update({
    id: '/products/bulk-import/',
    path: '/products/bulk-import/',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppFunnelProductIdLayoutFunnelRoute =
  AppFunnelProductIdLayoutFunnelRouteImport.update({
    id: '/_layout-funnel',
    getParentRoute: () => AppFunnelProductIdRoute,
  } as any)
const AppFunnelBulkImportIdLoadingRoute =
  AppFunnelBulkImportIdLoadingRouteImport.update({
    id: '/funnel/bulk-import/$id/loading',
    path: '/funnel/bulk-import/$id/loading',
    getParentRoute: () => AppRoute,
  } as any)
const AppFunnelIdLayoutFunnelTitleRoute =
  AppFunnelIdLayoutFunnelTitleRouteImport.update({
    id: '/title',
    path: '/title',
    getParentRoute: () => AppFunnelIdLayoutFunnelRoute,
  } as any)
const AppFunnelIdLayoutFunnelOutlinesRoute =
  AppFunnelIdLayoutFunnelOutlinesRouteImport.update({
    id: '/outlines',
    path: '/outlines',
    getParentRoute: () => AppFunnelIdLayoutFunnelRoute,
  } as any)
const AppFunnelIdLayoutFunnelCustomizeContentRoute =
  AppFunnelIdLayoutFunnelCustomizeContentRouteImport.update({
    id: '/customize-content',
    path: '/customize-content',
    getParentRoute: () => AppFunnelIdLayoutFunnelRoute,
  } as any)
const AppFunnelIdLayoutFunnelContentRoute =
  AppFunnelIdLayoutFunnelContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AppFunnelIdLayoutFunnelRoute,
  } as any)
const AppSidebarLayoutSeoStrategyBrandIdOverviewRoute =
  AppSidebarLayoutSeoStrategyBrandIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppSidebarLayoutSeoStrategyBrandIdRoute,
  } as any)
const AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute =
  AppSidebarLayoutSeoStrategyBrandIdKeywordsRouteImport.update({
    id: '/keywords',
    path: '/keywords',
    getParentRoute: () => AppSidebarLayoutSeoStrategyBrandIdRoute,
  } as any)
const AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute =
  AppSidebarLayoutSeoStrategyBrandIdActionPlanRouteImport.update({
    id: '/action-plan',
    path: '/action-plan',
    getParentRoute: () => AppSidebarLayoutSeoStrategyBrandIdRoute,
  } as any)
const AppSidebarLayoutProductsBulkImportIdRoute =
  AppSidebarLayoutProductsBulkImportIdRouteImport.update({
    id: '/products/bulk-import/$id',
    path: '/products/bulk-import/$id',
    getParentRoute: () => AppSidebarLayoutRoute,
  } as any)
const AppFunnelProductIdLayoutFunnelIndexRoute =
  AppFunnelProductIdLayoutFunnelIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFunnelProductIdLayoutFunnelRoute,
  } as any)
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteImport.update({
    id: '/_tabs-layout',
    getParentRoute: () => AppSettingsSidebarSettingsLayoutOrganizationIdRoute,
  } as any)
const AppFunnelProductIdLayoutFunnelProductInfoRoute =
  AppFunnelProductIdLayoutFunnelProductInfoRouteImport.update({
    id: '/product-info',
    path: '/product-info',
    getParentRoute: () => AppFunnelProductIdLayoutFunnelRoute,
  } as any)
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRouteImport.update(
    {
      id: '/users',
      path: '/users',
      getParentRoute: () =>
        AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute,
    } as any,
  )
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRouteImport.update(
    {
      id: '/plan',
      path: '/plan',
      getParentRoute: () =>
        AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute,
    } as any,
  )
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRouteImport.update(
    {
      id: '/integrations',
      path: '/integrations',
      getParentRoute: () =>
        AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute,
    } as any,
  )
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRouteImport.update(
    {
      id: '/brands',
      path: '/brands',
      getParentRoute: () =>
        AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute,
    } as any,
  )
const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRouteImport.update(
    {
      id: '/billing-legacy',
      path: '/billing-legacy',
      getParentRoute: () =>
        AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/*': typeof Char42Route
  '/app': typeof AppSidebarLayoutRouteWithChildren
  '/app/invite': typeof AppInviteRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/oauthcb': typeof AuthOauthcbRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/wait-user': typeof AuthWaitUserRoute
  '/auth': typeof AuthIndexRoute
  '/app/no-brand': typeof AppScreenNoBrandRoute
  '/app/removed-org': typeof AppScreenRemovedOrgRoute
  '/app/bookcall/$orgId': typeof AppBookcallOrgIdRoute
  '/app/check-checkout-session/$orgId': typeof AppCheckCheckoutSessionOrgIdRoute
  '/app/content/$id': typeof AppContentIdRoute
  '/app/product-template/new': typeof AppProductTemplateNewRoute
  '/app/product/$id': typeof AppProductIdRoute
  '/app/settings': typeof AppSettingsSidebarSettingsLayoutRouteWithChildren
  '/app/': typeof AppSidebarLayoutIndexRoute
  '/app/onboarding': typeof AppOnboardingIndexRoute
  '/app/products/templates': typeof AppSidebarLayoutProductsTemplatesRoute
  '/app/seo-strategy/$brandId': typeof AppSidebarLayoutSeoStrategyBrandIdRouteWithChildren
  '/app/funnel/$id': typeof AppFunnelIdLayoutFunnelRouteWithChildren
  '/app/product-template/$id/edit': typeof AppProductTemplateIdEditRoute
  '/app/settings/notifications': typeof AppSettingsSidebarSettingsLayoutNotificationsRoute
  '/app/settings/user': typeof AppSettingsSidebarSettingsLayoutUserRoute
  '/app/blogs': typeof AppSidebarLayoutBlogsIndexRoute
  '/app/brand-context': typeof AppSidebarLayoutBrandContextIndexRoute
  '/app/products': typeof AppSidebarLayoutProductsIndexRoute
  '/app/seo-strategy': typeof AppSidebarLayoutSeoStrategyIndexRoute
  '/app/products/bulk-import/$id': typeof AppSidebarLayoutProductsBulkImportIdRoute
  '/app/seo-strategy/$brandId/action-plan': typeof AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute
  '/app/seo-strategy/$brandId/keywords': typeof AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute
  '/app/seo-strategy/$brandId/overview': typeof AppSidebarLayoutSeoStrategyBrandIdOverviewRoute
  '/app/funnel/$id/content': typeof AppFunnelIdLayoutFunnelContentRoute
  '/app/funnel/$id/customize-content': typeof AppFunnelIdLayoutFunnelCustomizeContentRoute
  '/app/funnel/$id/outlines': typeof AppFunnelIdLayoutFunnelOutlinesRoute
  '/app/funnel/$id/product-index': typeof AppFunnelIdLayoutFunnelProductIndexRoute
  '/app/funnel/$id/title': typeof AppFunnelIdLayoutFunnelTitleRoute
  '/app/funnel/bulk-import/$id/loading': typeof AppFunnelBulkImportIdLoadingRoute
  '/app/funnel/product/$id': typeof AppFunnelProductIdLayoutFunnelRouteWithChildren
  '/app/products/bulk-import': typeof AppSidebarLayoutProductsBulkImportIndexRoute
  '/app/seo-strategy/$brandId/': typeof AppSidebarLayoutSeoStrategyBrandIdIndexRoute
  '/app/funnel/bulk-import/$id': typeof AppFunnelBulkImportIdIndexRoute
  '/app/funnel/product/$id/product-info': typeof AppFunnelProductIdLayoutFunnelProductInfoRoute
  '/app/settings/organization/$id': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren
  '/app/funnel/product/$id/': typeof AppFunnelProductIdLayoutFunnelIndexRoute
  '/app/settings/organization/$id/billing-legacy': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute
  '/app/settings/organization/$id/brands': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute
  '/app/settings/organization/$id/integrations': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute
  '/app/settings/organization/$id/plan': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute
  '/app/settings/organization/$id/users': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute
}
export interface FileRoutesByTo {
  '/*': typeof Char42Route
  '/app': typeof AppSidebarLayoutIndexRoute
  '/app/invite': typeof AppInviteRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/oauthcb': typeof AuthOauthcbRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/wait-user': typeof AuthWaitUserRoute
  '/auth': typeof AuthIndexRoute
  '/app/no-brand': typeof AppScreenNoBrandRoute
  '/app/removed-org': typeof AppScreenRemovedOrgRoute
  '/app/bookcall/$orgId': typeof AppBookcallOrgIdRoute
  '/app/check-checkout-session/$orgId': typeof AppCheckCheckoutSessionOrgIdRoute
  '/app/content/$id': typeof AppContentIdRoute
  '/app/product-template/new': typeof AppProductTemplateNewRoute
  '/app/product/$id': typeof AppProductIdRoute
  '/app/settings': typeof AppSettingsSidebarSettingsLayoutRouteWithChildren
  '/app/onboarding': typeof AppOnboardingIndexRoute
  '/app/products/templates': typeof AppSidebarLayoutProductsTemplatesRoute
  '/app/funnel/$id': typeof AppFunnelIdLayoutFunnelRouteWithChildren
  '/app/product-template/$id/edit': typeof AppProductTemplateIdEditRoute
  '/app/settings/notifications': typeof AppSettingsSidebarSettingsLayoutNotificationsRoute
  '/app/settings/user': typeof AppSettingsSidebarSettingsLayoutUserRoute
  '/app/blogs': typeof AppSidebarLayoutBlogsIndexRoute
  '/app/brand-context': typeof AppSidebarLayoutBrandContextIndexRoute
  '/app/products': typeof AppSidebarLayoutProductsIndexRoute
  '/app/seo-strategy': typeof AppSidebarLayoutSeoStrategyIndexRoute
  '/app/products/bulk-import/$id': typeof AppSidebarLayoutProductsBulkImportIdRoute
  '/app/seo-strategy/$brandId/action-plan': typeof AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute
  '/app/seo-strategy/$brandId/keywords': typeof AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute
  '/app/seo-strategy/$brandId/overview': typeof AppSidebarLayoutSeoStrategyBrandIdOverviewRoute
  '/app/funnel/$id/content': typeof AppFunnelIdLayoutFunnelContentRoute
  '/app/funnel/$id/customize-content': typeof AppFunnelIdLayoutFunnelCustomizeContentRoute
  '/app/funnel/$id/outlines': typeof AppFunnelIdLayoutFunnelOutlinesRoute
  '/app/funnel/$id/product-index': typeof AppFunnelIdLayoutFunnelProductIndexRoute
  '/app/funnel/$id/title': typeof AppFunnelIdLayoutFunnelTitleRoute
  '/app/funnel/bulk-import/$id/loading': typeof AppFunnelBulkImportIdLoadingRoute
  '/app/funnel/product/$id': typeof AppFunnelProductIdLayoutFunnelIndexRoute
  '/app/products/bulk-import': typeof AppSidebarLayoutProductsBulkImportIndexRoute
  '/app/seo-strategy/$brandId': typeof AppSidebarLayoutSeoStrategyBrandIdIndexRoute
  '/app/funnel/bulk-import/$id': typeof AppFunnelBulkImportIdIndexRoute
  '/app/funnel/product/$id/product-info': typeof AppFunnelProductIdLayoutFunnelProductInfoRoute
  '/app/settings/organization/$id': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren
  '/app/settings/organization/$id/billing-legacy': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute
  '/app/settings/organization/$id/brands': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute
  '/app/settings/organization/$id/integrations': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute
  '/app/settings/organization/$id/plan': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute
  '/app/settings/organization/$id/users': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/*': typeof Char42Route
  '/app': typeof AppRouteWithChildren
  '/app/_sidebar-layout': typeof AppSidebarLayoutRouteWithChildren
  '/app/invite': typeof AppInviteRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/oauthcb': typeof AuthOauthcbRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/wait-user': typeof AuthWaitUserRoute
  '/auth/': typeof AuthIndexRoute
  '/app/_screen/no-brand': typeof AppScreenNoBrandRoute
  '/app/_screen/removed-org': typeof AppScreenRemovedOrgRoute
  '/app/bookcall/$orgId': typeof AppBookcallOrgIdRoute
  '/app/check-checkout-session/$orgId': typeof AppCheckCheckoutSessionOrgIdRoute
  '/app/content/$id': typeof AppContentIdRoute
  '/app/product-template/new': typeof AppProductTemplateNewRoute
  '/app/product/$id': typeof AppProductIdRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/settings/_sidebar-settings-layout': typeof AppSettingsSidebarSettingsLayoutRouteWithChildren
  '/app/_sidebar-layout/': typeof AppSidebarLayoutIndexRoute
  '/app/onboarding/': typeof AppOnboardingIndexRoute
  '/app/_sidebar-layout/products/templates': typeof AppSidebarLayoutProductsTemplatesRoute
  '/app/_sidebar-layout/seo-strategy/$brandId': typeof AppSidebarLayoutSeoStrategyBrandIdRouteWithChildren
  '/app/funnel/$id': typeof AppFunnelIdRouteWithChildren
  '/app/funnel/$id/_layout-funnel': typeof AppFunnelIdLayoutFunnelRouteWithChildren
  '/app/product-template/$id/edit': typeof AppProductTemplateIdEditRoute
  '/app/settings/_sidebar-settings-layout/notifications': typeof AppSettingsSidebarSettingsLayoutNotificationsRoute
  '/app/settings/_sidebar-settings-layout/user': typeof AppSettingsSidebarSettingsLayoutUserRoute
  '/app/_sidebar-layout/blogs/': typeof AppSidebarLayoutBlogsIndexRoute
  '/app/_sidebar-layout/brand-context/': typeof AppSidebarLayoutBrandContextIndexRoute
  '/app/_sidebar-layout/products/': typeof AppSidebarLayoutProductsIndexRoute
  '/app/_sidebar-layout/seo-strategy/': typeof AppSidebarLayoutSeoStrategyIndexRoute
  '/app/_sidebar-layout/products/bulk-import/$id': typeof AppSidebarLayoutProductsBulkImportIdRoute
  '/app/_sidebar-layout/seo-strategy/$brandId/action-plan': typeof AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute
  '/app/_sidebar-layout/seo-strategy/$brandId/keywords': typeof AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute
  '/app/_sidebar-layout/seo-strategy/$brandId/overview': typeof AppSidebarLayoutSeoStrategyBrandIdOverviewRoute
  '/app/funnel/$id/_layout-funnel/content': typeof AppFunnelIdLayoutFunnelContentRoute
  '/app/funnel/$id/_layout-funnel/customize-content': typeof AppFunnelIdLayoutFunnelCustomizeContentRoute
  '/app/funnel/$id/_layout-funnel/outlines': typeof AppFunnelIdLayoutFunnelOutlinesRoute
  '/app/funnel/$id/_layout-funnel/product-index': typeof AppFunnelIdLayoutFunnelProductIndexRoute
  '/app/funnel/$id/_layout-funnel/title': typeof AppFunnelIdLayoutFunnelTitleRoute
  '/app/funnel/bulk-import/$id/loading': typeof AppFunnelBulkImportIdLoadingRoute
  '/app/funnel/product/$id': typeof AppFunnelProductIdRouteWithChildren
  '/app/funnel/product/$id/_layout-funnel': typeof AppFunnelProductIdLayoutFunnelRouteWithChildren
  '/app/_sidebar-layout/products/bulk-import/': typeof AppSidebarLayoutProductsBulkImportIndexRoute
  '/app/_sidebar-layout/seo-strategy/$brandId/': typeof AppSidebarLayoutSeoStrategyBrandIdIndexRoute
  '/app/funnel/bulk-import/$id/': typeof AppFunnelBulkImportIdIndexRoute
  '/app/funnel/product/$id/_layout-funnel/product-info': typeof AppFunnelProductIdLayoutFunnelProductInfoRoute
  '/app/settings/_sidebar-settings-layout/organization/$id': typeof AppSettingsSidebarSettingsLayoutOrganizationIdRouteWithChildren
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren
  '/app/funnel/product/$id/_layout-funnel/': typeof AppFunnelProductIdLayoutFunnelIndexRoute
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing-legacy': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/brands': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/integrations': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/plan': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/users': typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/*'
    | '/app'
    | '/app/invite'
    | '/auth/forgot'
    | '/auth/oauthcb'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/wait-user'
    | '/auth'
    | '/app/no-brand'
    | '/app/removed-org'
    | '/app/bookcall/$orgId'
    | '/app/check-checkout-session/$orgId'
    | '/app/content/$id'
    | '/app/product-template/new'
    | '/app/product/$id'
    | '/app/settings'
    | '/app/'
    | '/app/onboarding'
    | '/app/products/templates'
    | '/app/seo-strategy/$brandId'
    | '/app/funnel/$id'
    | '/app/product-template/$id/edit'
    | '/app/settings/notifications'
    | '/app/settings/user'
    | '/app/blogs'
    | '/app/brand-context'
    | '/app/products'
    | '/app/seo-strategy'
    | '/app/products/bulk-import/$id'
    | '/app/seo-strategy/$brandId/action-plan'
    | '/app/seo-strategy/$brandId/keywords'
    | '/app/seo-strategy/$brandId/overview'
    | '/app/funnel/$id/content'
    | '/app/funnel/$id/customize-content'
    | '/app/funnel/$id/outlines'
    | '/app/funnel/$id/product-index'
    | '/app/funnel/$id/title'
    | '/app/funnel/bulk-import/$id/loading'
    | '/app/funnel/product/$id'
    | '/app/products/bulk-import'
    | '/app/seo-strategy/$brandId/'
    | '/app/funnel/bulk-import/$id'
    | '/app/funnel/product/$id/product-info'
    | '/app/settings/organization/$id'
    | '/app/funnel/product/$id/'
    | '/app/settings/organization/$id/billing-legacy'
    | '/app/settings/organization/$id/brands'
    | '/app/settings/organization/$id/integrations'
    | '/app/settings/organization/$id/plan'
    | '/app/settings/organization/$id/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/*'
    | '/app'
    | '/app/invite'
    | '/auth/forgot'
    | '/auth/oauthcb'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/wait-user'
    | '/auth'
    | '/app/no-brand'
    | '/app/removed-org'
    | '/app/bookcall/$orgId'
    | '/app/check-checkout-session/$orgId'
    | '/app/content/$id'
    | '/app/product-template/new'
    | '/app/product/$id'
    | '/app/settings'
    | '/app/onboarding'
    | '/app/products/templates'
    | '/app/funnel/$id'
    | '/app/product-template/$id/edit'
    | '/app/settings/notifications'
    | '/app/settings/user'
    | '/app/blogs'
    | '/app/brand-context'
    | '/app/products'
    | '/app/seo-strategy'
    | '/app/products/bulk-import/$id'
    | '/app/seo-strategy/$brandId/action-plan'
    | '/app/seo-strategy/$brandId/keywords'
    | '/app/seo-strategy/$brandId/overview'
    | '/app/funnel/$id/content'
    | '/app/funnel/$id/customize-content'
    | '/app/funnel/$id/outlines'
    | '/app/funnel/$id/product-index'
    | '/app/funnel/$id/title'
    | '/app/funnel/bulk-import/$id/loading'
    | '/app/funnel/product/$id'
    | '/app/products/bulk-import'
    | '/app/seo-strategy/$brandId'
    | '/app/funnel/bulk-import/$id'
    | '/app/funnel/product/$id/product-info'
    | '/app/settings/organization/$id'
    | '/app/settings/organization/$id/billing-legacy'
    | '/app/settings/organization/$id/brands'
    | '/app/settings/organization/$id/integrations'
    | '/app/settings/organization/$id/plan'
    | '/app/settings/organization/$id/users'
  id:
    | '__root__'
    | '/*'
    | '/app'
    | '/app/_sidebar-layout'
    | '/app/invite'
    | '/auth/forgot'
    | '/auth/oauthcb'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/wait-user'
    | '/auth/'
    | '/app/_screen/no-brand'
    | '/app/_screen/removed-org'
    | '/app/bookcall/$orgId'
    | '/app/check-checkout-session/$orgId'
    | '/app/content/$id'
    | '/app/product-template/new'
    | '/app/product/$id'
    | '/app/settings'
    | '/app/settings/_sidebar-settings-layout'
    | '/app/_sidebar-layout/'
    | '/app/onboarding/'
    | '/app/_sidebar-layout/products/templates'
    | '/app/_sidebar-layout/seo-strategy/$brandId'
    | '/app/funnel/$id'
    | '/app/funnel/$id/_layout-funnel'
    | '/app/product-template/$id/edit'
    | '/app/settings/_sidebar-settings-layout/notifications'
    | '/app/settings/_sidebar-settings-layout/user'
    | '/app/_sidebar-layout/blogs/'
    | '/app/_sidebar-layout/brand-context/'
    | '/app/_sidebar-layout/products/'
    | '/app/_sidebar-layout/seo-strategy/'
    | '/app/_sidebar-layout/products/bulk-import/$id'
    | '/app/_sidebar-layout/seo-strategy/$brandId/action-plan'
    | '/app/_sidebar-layout/seo-strategy/$brandId/keywords'
    | '/app/_sidebar-layout/seo-strategy/$brandId/overview'
    | '/app/funnel/$id/_layout-funnel/content'
    | '/app/funnel/$id/_layout-funnel/customize-content'
    | '/app/funnel/$id/_layout-funnel/outlines'
    | '/app/funnel/$id/_layout-funnel/product-index'
    | '/app/funnel/$id/_layout-funnel/title'
    | '/app/funnel/bulk-import/$id/loading'
    | '/app/funnel/product/$id'
    | '/app/funnel/product/$id/_layout-funnel'
    | '/app/_sidebar-layout/products/bulk-import/'
    | '/app/_sidebar-layout/seo-strategy/$brandId/'
    | '/app/funnel/bulk-import/$id/'
    | '/app/funnel/product/$id/_layout-funnel/product-info'
    | '/app/settings/_sidebar-settings-layout/organization/$id'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout'
    | '/app/funnel/product/$id/_layout-funnel/'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing-legacy'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/brands'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/integrations'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/plan'
    | '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char42Route: typeof Char42Route
  AppRoute: typeof AppRouteWithChildren
  AuthForgotRoute: typeof AuthForgotRoute
  AuthOauthcbRoute: typeof AuthOauthcbRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthWaitUserRoute: typeof AuthWaitUserRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/*': {
      id: '/*'
      path: '/*'
      fullPath: '/*'
      preLoaderRoute: typeof Char42RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/wait-user': {
      id: '/auth/wait-user'
      path: '/auth/wait-user'
      fullPath: '/auth/wait-user'
      preLoaderRoute: typeof AuthWaitUserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/oauthcb': {
      id: '/auth/oauthcb'
      path: '/auth/oauthcb'
      fullPath: '/auth/oauthcb'
      preLoaderRoute: typeof AuthOauthcbRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/auth/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/invite': {
      id: '/app/invite'
      path: '/invite'
      fullPath: '/app/invite'
      preLoaderRoute: typeof AppInviteRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_sidebar-layout': {
      id: '/app/_sidebar-layout'
      path: ''
      fullPath: '/app'
      preLoaderRoute: typeof AppSidebarLayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/funnel/$id': {
      id: '/app/funnel/$id'
      path: '/funnel/$id'
      fullPath: '/app/funnel/$id'
      preLoaderRoute: typeof AppFunnelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/': {
      id: '/app/onboarding/'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_sidebar-layout/': {
      id: '/app/_sidebar-layout/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppSidebarLayoutIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout': {
      id: '/app/settings/_sidebar-settings-layout'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/product/$id': {
      id: '/app/product/$id'
      path: '/product/$id'
      fullPath: '/app/product/$id'
      preLoaderRoute: typeof AppProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/product-template/new': {
      id: '/app/product-template/new'
      path: '/product-template/new'
      fullPath: '/app/product-template/new'
      preLoaderRoute: typeof AppProductTemplateNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/content/$id': {
      id: '/app/content/$id'
      path: '/content/$id'
      fullPath: '/app/content/$id'
      preLoaderRoute: typeof AppContentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/check-checkout-session/$orgId': {
      id: '/app/check-checkout-session/$orgId'
      path: '/check-checkout-session/$orgId'
      fullPath: '/app/check-checkout-session/$orgId'
      preLoaderRoute: typeof AppCheckCheckoutSessionOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/bookcall/$orgId': {
      id: '/app/bookcall/$orgId'
      path: '/bookcall/$orgId'
      fullPath: '/app/bookcall/$orgId'
      preLoaderRoute: typeof AppBookcallOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_screen/removed-org': {
      id: '/app/_screen/removed-org'
      path: '/removed-org'
      fullPath: '/app/removed-org'
      preLoaderRoute: typeof AppScreenRemovedOrgRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_screen/no-brand': {
      id: '/app/_screen/no-brand'
      path: '/no-brand'
      fullPath: '/app/no-brand'
      preLoaderRoute: typeof AppScreenNoBrandRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/funnel/product/$id': {
      id: '/app/funnel/product/$id'
      path: '/funnel/product/$id'
      fullPath: '/app/funnel/product/$id'
      preLoaderRoute: typeof AppFunnelProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_sidebar-layout/seo-strategy/': {
      id: '/app/_sidebar-layout/seo-strategy/'
      path: '/seo-strategy'
      fullPath: '/app/seo-strategy'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/_sidebar-layout/products/': {
      id: '/app/_sidebar-layout/products/'
      path: '/products'
      fullPath: '/app/products'
      preLoaderRoute: typeof AppSidebarLayoutProductsIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/_sidebar-layout/brand-context/': {
      id: '/app/_sidebar-layout/brand-context/'
      path: '/brand-context'
      fullPath: '/app/brand-context'
      preLoaderRoute: typeof AppSidebarLayoutBrandContextIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/_sidebar-layout/blogs/': {
      id: '/app/_sidebar-layout/blogs/'
      path: '/blogs'
      fullPath: '/app/blogs'
      preLoaderRoute: typeof AppSidebarLayoutBlogsIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/user': {
      id: '/app/settings/_sidebar-settings-layout/user'
      path: '/user'
      fullPath: '/app/settings/user'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutUserRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/notifications': {
      id: '/app/settings/_sidebar-settings-layout/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutNotificationsRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutRoute
    }
    '/app/product-template/$id/edit': {
      id: '/app/product-template/$id/edit'
      path: '/product-template/$id/edit'
      fullPath: '/app/product-template/$id/edit'
      preLoaderRoute: typeof AppProductTemplateIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/funnel/$id/_layout-funnel': {
      id: '/app/funnel/$id/_layout-funnel'
      path: '/funnel/$id'
      fullPath: '/app/funnel/$id'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelRouteImport
      parentRoute: typeof AppFunnelIdRoute
    }
    '/app/_sidebar-layout/seo-strategy/$brandId': {
      id: '/app/_sidebar-layout/seo-strategy/$brandId'
      path: '/seo-strategy/$brandId'
      fullPath: '/app/seo-strategy/$brandId'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/_sidebar-layout/products/templates': {
      id: '/app/_sidebar-layout/products/templates'
      path: '/products/templates'
      fullPath: '/app/products/templates'
      preLoaderRoute: typeof AppSidebarLayoutProductsTemplatesRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/funnel/$id/_layout-funnel/product-index': {
      id: '/app/funnel/$id/_layout-funnel/product-index'
      path: '/product-index'
      fullPath: '/app/funnel/$id/product-index'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelProductIndexRouteImport
      parentRoute: typeof AppFunnelIdLayoutFunnelRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id'
      path: '/organization/$id'
      fullPath: '/app/settings/organization/$id'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutRoute
    }
    '/app/funnel/bulk-import/$id/': {
      id: '/app/funnel/bulk-import/$id/'
      path: '/funnel/bulk-import/$id'
      fullPath: '/app/funnel/bulk-import/$id'
      preLoaderRoute: typeof AppFunnelBulkImportIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_sidebar-layout/seo-strategy/$brandId/': {
      id: '/app/_sidebar-layout/seo-strategy/$brandId/'
      path: '/'
      fullPath: '/app/seo-strategy/$brandId/'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyBrandIdIndexRouteImport
      parentRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRoute
    }
    '/app/_sidebar-layout/products/bulk-import/': {
      id: '/app/_sidebar-layout/products/bulk-import/'
      path: '/products/bulk-import'
      fullPath: '/app/products/bulk-import'
      preLoaderRoute: typeof AppSidebarLayoutProductsBulkImportIndexRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/funnel/product/$id/_layout-funnel': {
      id: '/app/funnel/product/$id/_layout-funnel'
      path: '/funnel/product/$id'
      fullPath: '/app/funnel/product/$id'
      preLoaderRoute: typeof AppFunnelProductIdLayoutFunnelRouteImport
      parentRoute: typeof AppFunnelProductIdRoute
    }
    '/app/funnel/bulk-import/$id/loading': {
      id: '/app/funnel/bulk-import/$id/loading'
      path: '/funnel/bulk-import/$id/loading'
      fullPath: '/app/funnel/bulk-import/$id/loading'
      preLoaderRoute: typeof AppFunnelBulkImportIdLoadingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/funnel/$id/_layout-funnel/title': {
      id: '/app/funnel/$id/_layout-funnel/title'
      path: '/title'
      fullPath: '/app/funnel/$id/title'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelTitleRouteImport
      parentRoute: typeof AppFunnelIdLayoutFunnelRoute
    }
    '/app/funnel/$id/_layout-funnel/outlines': {
      id: '/app/funnel/$id/_layout-funnel/outlines'
      path: '/outlines'
      fullPath: '/app/funnel/$id/outlines'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelOutlinesRouteImport
      parentRoute: typeof AppFunnelIdLayoutFunnelRoute
    }
    '/app/funnel/$id/_layout-funnel/customize-content': {
      id: '/app/funnel/$id/_layout-funnel/customize-content'
      path: '/customize-content'
      fullPath: '/app/funnel/$id/customize-content'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelCustomizeContentRouteImport
      parentRoute: typeof AppFunnelIdLayoutFunnelRoute
    }
    '/app/funnel/$id/_layout-funnel/content': {
      id: '/app/funnel/$id/_layout-funnel/content'
      path: '/content'
      fullPath: '/app/funnel/$id/content'
      preLoaderRoute: typeof AppFunnelIdLayoutFunnelContentRouteImport
      parentRoute: typeof AppFunnelIdLayoutFunnelRoute
    }
    '/app/_sidebar-layout/seo-strategy/$brandId/overview': {
      id: '/app/_sidebar-layout/seo-strategy/$brandId/overview'
      path: '/overview'
      fullPath: '/app/seo-strategy/$brandId/overview'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyBrandIdOverviewRouteImport
      parentRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRoute
    }
    '/app/_sidebar-layout/seo-strategy/$brandId/keywords': {
      id: '/app/_sidebar-layout/seo-strategy/$brandId/keywords'
      path: '/keywords'
      fullPath: '/app/seo-strategy/$brandId/keywords'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyBrandIdKeywordsRouteImport
      parentRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRoute
    }
    '/app/_sidebar-layout/seo-strategy/$brandId/action-plan': {
      id: '/app/_sidebar-layout/seo-strategy/$brandId/action-plan'
      path: '/action-plan'
      fullPath: '/app/seo-strategy/$brandId/action-plan'
      preLoaderRoute: typeof AppSidebarLayoutSeoStrategyBrandIdActionPlanRouteImport
      parentRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRoute
    }
    '/app/_sidebar-layout/products/bulk-import/$id': {
      id: '/app/_sidebar-layout/products/bulk-import/$id'
      path: '/products/bulk-import/$id'
      fullPath: '/app/products/bulk-import/$id'
      preLoaderRoute: typeof AppSidebarLayoutProductsBulkImportIdRouteImport
      parentRoute: typeof AppSidebarLayoutRoute
    }
    '/app/funnel/product/$id/_layout-funnel/': {
      id: '/app/funnel/product/$id/_layout-funnel/'
      path: '/'
      fullPath: '/app/funnel/product/$id/'
      preLoaderRoute: typeof AppFunnelProductIdLayoutFunnelIndexRouteImport
      parentRoute: typeof AppFunnelProductIdLayoutFunnelRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout'
      path: '/organization/$id'
      fullPath: '/app/settings/organization/$id'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdRoute
    }
    '/app/funnel/product/$id/_layout-funnel/product-info': {
      id: '/app/funnel/product/$id/_layout-funnel/product-info'
      path: '/product-info'
      fullPath: '/app/funnel/product/$id/product-info'
      preLoaderRoute: typeof AppFunnelProductIdLayoutFunnelProductInfoRouteImport
      parentRoute: typeof AppFunnelProductIdLayoutFunnelRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/users': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/users'
      path: '/users'
      fullPath: '/app/settings/organization/$id/users'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/plan': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/plan'
      path: '/plan'
      fullPath: '/app/settings/organization/$id/plan'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/integrations': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/integrations'
      path: '/integrations'
      fullPath: '/app/settings/organization/$id/integrations'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/brands': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/brands'
      path: '/brands'
      fullPath: '/app/settings/organization/$id/brands'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute
    }
    '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing-legacy': {
      id: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing-legacy'
      path: '/billing-legacy'
      fullPath: '/app/settings/organization/$id/billing-legacy'
      preLoaderRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRouteImport
      parentRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute
    }
  }
}

interface AppSidebarLayoutSeoStrategyBrandIdRouteChildren {
  AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute: typeof AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute
  AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute: typeof AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute
  AppSidebarLayoutSeoStrategyBrandIdOverviewRoute: typeof AppSidebarLayoutSeoStrategyBrandIdOverviewRoute
  AppSidebarLayoutSeoStrategyBrandIdIndexRoute: typeof AppSidebarLayoutSeoStrategyBrandIdIndexRoute
}

const AppSidebarLayoutSeoStrategyBrandIdRouteChildren: AppSidebarLayoutSeoStrategyBrandIdRouteChildren =
  {
    AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute:
      AppSidebarLayoutSeoStrategyBrandIdActionPlanRoute,
    AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute:
      AppSidebarLayoutSeoStrategyBrandIdKeywordsRoute,
    AppSidebarLayoutSeoStrategyBrandIdOverviewRoute:
      AppSidebarLayoutSeoStrategyBrandIdOverviewRoute,
    AppSidebarLayoutSeoStrategyBrandIdIndexRoute:
      AppSidebarLayoutSeoStrategyBrandIdIndexRoute,
  }

const AppSidebarLayoutSeoStrategyBrandIdRouteWithChildren =
  AppSidebarLayoutSeoStrategyBrandIdRoute._addFileChildren(
    AppSidebarLayoutSeoStrategyBrandIdRouteChildren,
  )

interface AppSidebarLayoutRouteChildren {
  AppSidebarLayoutIndexRoute: typeof AppSidebarLayoutIndexRoute
  AppSidebarLayoutProductsTemplatesRoute: typeof AppSidebarLayoutProductsTemplatesRoute
  AppSidebarLayoutSeoStrategyBrandIdRoute: typeof AppSidebarLayoutSeoStrategyBrandIdRouteWithChildren
  AppSidebarLayoutBlogsIndexRoute: typeof AppSidebarLayoutBlogsIndexRoute
  AppSidebarLayoutBrandContextIndexRoute: typeof AppSidebarLayoutBrandContextIndexRoute
  AppSidebarLayoutProductsIndexRoute: typeof AppSidebarLayoutProductsIndexRoute
  AppSidebarLayoutSeoStrategyIndexRoute: typeof AppSidebarLayoutSeoStrategyIndexRoute
  AppSidebarLayoutProductsBulkImportIdRoute: typeof AppSidebarLayoutProductsBulkImportIdRoute
  AppSidebarLayoutProductsBulkImportIndexRoute: typeof AppSidebarLayoutProductsBulkImportIndexRoute
}

const AppSidebarLayoutRouteChildren: AppSidebarLayoutRouteChildren = {
  AppSidebarLayoutIndexRoute: AppSidebarLayoutIndexRoute,
  AppSidebarLayoutProductsTemplatesRoute:
    AppSidebarLayoutProductsTemplatesRoute,
  AppSidebarLayoutSeoStrategyBrandIdRoute:
    AppSidebarLayoutSeoStrategyBrandIdRouteWithChildren,
  AppSidebarLayoutBlogsIndexRoute: AppSidebarLayoutBlogsIndexRoute,
  AppSidebarLayoutBrandContextIndexRoute:
    AppSidebarLayoutBrandContextIndexRoute,
  AppSidebarLayoutProductsIndexRoute: AppSidebarLayoutProductsIndexRoute,
  AppSidebarLayoutSeoStrategyIndexRoute: AppSidebarLayoutSeoStrategyIndexRoute,
  AppSidebarLayoutProductsBulkImportIdRoute:
    AppSidebarLayoutProductsBulkImportIdRoute,
  AppSidebarLayoutProductsBulkImportIndexRoute:
    AppSidebarLayoutProductsBulkImportIndexRoute,
}

const AppSidebarLayoutRouteWithChildren =
  AppSidebarLayoutRoute._addFileChildren(AppSidebarLayoutRouteChildren)

interface AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteChildren {
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute
}

const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteChildren: AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteChildren =
  {
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBillingLegacyRoute,
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutBrandsRoute,
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutIntegrationsRoute,
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutPlanRoute,
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutUsersRoute,
  }

const AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren =
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute._addFileChildren(
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteChildren,
  )

interface AppSettingsSidebarSettingsLayoutOrganizationIdRouteChildren {
  AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren
}

const AppSettingsSidebarSettingsLayoutOrganizationIdRouteChildren: AppSettingsSidebarSettingsLayoutOrganizationIdRouteChildren =
  {
    AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdTabsLayoutRouteWithChildren,
  }

const AppSettingsSidebarSettingsLayoutOrganizationIdRouteWithChildren =
  AppSettingsSidebarSettingsLayoutOrganizationIdRoute._addFileChildren(
    AppSettingsSidebarSettingsLayoutOrganizationIdRouteChildren,
  )

interface AppSettingsSidebarSettingsLayoutRouteChildren {
  AppSettingsSidebarSettingsLayoutNotificationsRoute: typeof AppSettingsSidebarSettingsLayoutNotificationsRoute
  AppSettingsSidebarSettingsLayoutUserRoute: typeof AppSettingsSidebarSettingsLayoutUserRoute
  AppSettingsSidebarSettingsLayoutOrganizationIdRoute: typeof AppSettingsSidebarSettingsLayoutOrganizationIdRouteWithChildren
}

const AppSettingsSidebarSettingsLayoutRouteChildren: AppSettingsSidebarSettingsLayoutRouteChildren =
  {
    AppSettingsSidebarSettingsLayoutNotificationsRoute:
      AppSettingsSidebarSettingsLayoutNotificationsRoute,
    AppSettingsSidebarSettingsLayoutUserRoute:
      AppSettingsSidebarSettingsLayoutUserRoute,
    AppSettingsSidebarSettingsLayoutOrganizationIdRoute:
      AppSettingsSidebarSettingsLayoutOrganizationIdRouteWithChildren,
  }

const AppSettingsSidebarSettingsLayoutRouteWithChildren =
  AppSettingsSidebarSettingsLayoutRoute._addFileChildren(
    AppSettingsSidebarSettingsLayoutRouteChildren,
  )

interface AppSettingsRouteChildren {
  AppSettingsSidebarSettingsLayoutRoute: typeof AppSettingsSidebarSettingsLayoutRouteWithChildren
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsSidebarSettingsLayoutRoute:
    AppSettingsSidebarSettingsLayoutRouteWithChildren,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppFunnelIdLayoutFunnelRouteChildren {
  AppFunnelIdLayoutFunnelContentRoute: typeof AppFunnelIdLayoutFunnelContentRoute
  AppFunnelIdLayoutFunnelCustomizeContentRoute: typeof AppFunnelIdLayoutFunnelCustomizeContentRoute
  AppFunnelIdLayoutFunnelOutlinesRoute: typeof AppFunnelIdLayoutFunnelOutlinesRoute
  AppFunnelIdLayoutFunnelProductIndexRoute: typeof AppFunnelIdLayoutFunnelProductIndexRoute
  AppFunnelIdLayoutFunnelTitleRoute: typeof AppFunnelIdLayoutFunnelTitleRoute
}

const AppFunnelIdLayoutFunnelRouteChildren: AppFunnelIdLayoutFunnelRouteChildren =
  {
    AppFunnelIdLayoutFunnelContentRoute: AppFunnelIdLayoutFunnelContentRoute,
    AppFunnelIdLayoutFunnelCustomizeContentRoute:
      AppFunnelIdLayoutFunnelCustomizeContentRoute,
    AppFunnelIdLayoutFunnelOutlinesRoute: AppFunnelIdLayoutFunnelOutlinesRoute,
    AppFunnelIdLayoutFunnelProductIndexRoute:
      AppFunnelIdLayoutFunnelProductIndexRoute,
    AppFunnelIdLayoutFunnelTitleRoute: AppFunnelIdLayoutFunnelTitleRoute,
  }

const AppFunnelIdLayoutFunnelRouteWithChildren =
  AppFunnelIdLayoutFunnelRoute._addFileChildren(
    AppFunnelIdLayoutFunnelRouteChildren,
  )

interface AppFunnelIdRouteChildren {
  AppFunnelIdLayoutFunnelRoute: typeof AppFunnelIdLayoutFunnelRouteWithChildren
}

const AppFunnelIdRouteChildren: AppFunnelIdRouteChildren = {
  AppFunnelIdLayoutFunnelRoute: AppFunnelIdLayoutFunnelRouteWithChildren,
}

const AppFunnelIdRouteWithChildren = AppFunnelIdRoute._addFileChildren(
  AppFunnelIdRouteChildren,
)

interface AppFunnelProductIdLayoutFunnelRouteChildren {
  AppFunnelProductIdLayoutFunnelProductInfoRoute: typeof AppFunnelProductIdLayoutFunnelProductInfoRoute
  AppFunnelProductIdLayoutFunnelIndexRoute: typeof AppFunnelProductIdLayoutFunnelIndexRoute
}

const AppFunnelProductIdLayoutFunnelRouteChildren: AppFunnelProductIdLayoutFunnelRouteChildren =
  {
    AppFunnelProductIdLayoutFunnelProductInfoRoute:
      AppFunnelProductIdLayoutFunnelProductInfoRoute,
    AppFunnelProductIdLayoutFunnelIndexRoute:
      AppFunnelProductIdLayoutFunnelIndexRoute,
  }

const AppFunnelProductIdLayoutFunnelRouteWithChildren =
  AppFunnelProductIdLayoutFunnelRoute._addFileChildren(
    AppFunnelProductIdLayoutFunnelRouteChildren,
  )

interface AppFunnelProductIdRouteChildren {
  AppFunnelProductIdLayoutFunnelRoute: typeof AppFunnelProductIdLayoutFunnelRouteWithChildren
}

const AppFunnelProductIdRouteChildren: AppFunnelProductIdRouteChildren = {
  AppFunnelProductIdLayoutFunnelRoute:
    AppFunnelProductIdLayoutFunnelRouteWithChildren,
}

const AppFunnelProductIdRouteWithChildren =
  AppFunnelProductIdRoute._addFileChildren(AppFunnelProductIdRouteChildren)

interface AppRouteChildren {
  AppSidebarLayoutRoute: typeof AppSidebarLayoutRouteWithChildren
  AppInviteRoute: typeof AppInviteRoute
  AppScreenNoBrandRoute: typeof AppScreenNoBrandRoute
  AppScreenRemovedOrgRoute: typeof AppScreenRemovedOrgRoute
  AppBookcallOrgIdRoute: typeof AppBookcallOrgIdRoute
  AppCheckCheckoutSessionOrgIdRoute: typeof AppCheckCheckoutSessionOrgIdRoute
  AppContentIdRoute: typeof AppContentIdRoute
  AppProductTemplateNewRoute: typeof AppProductTemplateNewRoute
  AppProductIdRoute: typeof AppProductIdRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppFunnelIdRoute: typeof AppFunnelIdRouteWithChildren
  AppProductTemplateIdEditRoute: typeof AppProductTemplateIdEditRoute
  AppFunnelBulkImportIdLoadingRoute: typeof AppFunnelBulkImportIdLoadingRoute
  AppFunnelProductIdRoute: typeof AppFunnelProductIdRouteWithChildren
  AppFunnelBulkImportIdIndexRoute: typeof AppFunnelBulkImportIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSidebarLayoutRoute: AppSidebarLayoutRouteWithChildren,
  AppInviteRoute: AppInviteRoute,
  AppScreenNoBrandRoute: AppScreenNoBrandRoute,
  AppScreenRemovedOrgRoute: AppScreenRemovedOrgRoute,
  AppBookcallOrgIdRoute: AppBookcallOrgIdRoute,
  AppCheckCheckoutSessionOrgIdRoute: AppCheckCheckoutSessionOrgIdRoute,
  AppContentIdRoute: AppContentIdRoute,
  AppProductTemplateNewRoute: AppProductTemplateNewRoute,
  AppProductIdRoute: AppProductIdRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppFunnelIdRoute: AppFunnelIdRouteWithChildren,
  AppProductTemplateIdEditRoute: AppProductTemplateIdEditRoute,
  AppFunnelBulkImportIdLoadingRoute: AppFunnelBulkImportIdLoadingRoute,
  AppFunnelProductIdRoute: AppFunnelProductIdRouteWithChildren,
  AppFunnelBulkImportIdIndexRoute: AppFunnelBulkImportIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  Char42Route: Char42Route,
  AppRoute: AppRouteWithChildren,
  AuthForgotRoute: AuthForgotRoute,
  AuthOauthcbRoute: AuthOauthcbRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthWaitUserRoute: AuthWaitUserRoute,
  AuthIndexRoute: AuthIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
